/**
 * Created by qingzhui on 17/1/1.
 */

var moment = require('moment');

require('../../scss/m/m-index.scss');

var common = require('./m-common');

var $ = require('jquery');

$(function () {

    // 获取当前语言环境
    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();
    var page = 0;
    var records; // 新闻类型
    var totalPage = null;
    var isLoad = false;
    var $newsList = $('.list-news');
    
    //筛选
    var navHtm = '';
    var text = '';
    var $navList = $('.list-nav');
    var isFilter = false;

    // 请求的所有地址
    var ajaxUrl = {
        newList: baseUrl + 'v1/china/article',
        newListType: baseUrl + 'v1/newstype', // 分类型新闻数据查询接口
        typeList: baseUrl + 'v1/china/article/type' // 过滤新闻
    };

    $.ajax({
        url: ajaxUrl.newListType,
        type: 'get',
        dataType: 'json',
        data: {},
        success: function (data) {
            if (data.status) {
                // 成功进行回调
                // records = data.records;
                records=[
                    {code: 'news-reports', zh: '媒体报道', en: 'IN THE NEWS'},
                    {code: 'transactions', zh: '交易新闻', en: 'TRANSACTIONS'},
                    {code: 'company-news', zh: '公司新闻', en: 'CORPORATE NEWS'},
                    {code: 'events', zh: '活动新闻', en: 'EVENTS'}
                ]
                if(lang !== 'en') {
                    records.splice(3, 0,
        
                            {code: 'party-building-section', zh: '党建动态'}
                        
                    )
                }

                // 更新页面类型筛选
                for(var k = 0; k < records.length; k++){
                    text = lang === 'en' ? records[k].en : records[k].zh;
                    
                    navHtm += `<li><a class="${k==0?'active':''} ${lang === 'en'?'en':''}" href="javascript:;" data-type="${records[k].code}">${text}</a></li>`;
                }

                $navList.empty();
                $navList.append(navHtm);
                
                // 第一次加载数据
                getNewsList(ajaxUrl.typeList, page, lang);

                // $(document).scroll(function(){
                //     if(!isFilter){
                //         // var scrollTop = $('body').scrollTop();
                //         //处理的是滚动加载的问题
                //         var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                //         var wrapHeight = $(window).height();
                //         // console.log(scrollTop)
                //         //分页加载
                //         if(scrollTop + wrapHeight + 100 >= $('body')[0].scrollHeight && !isLoad){
                //             isLoad = true;
                //             page += 1;
                //             if(page > totalPage){
                //                 // console.log('最后一页！');
                //             }else{
                //                 getNewsList(ajaxUrl.typeList, page, lang);
                //                 // console.log('加载成功：' + page);
                //             }
                //         }
                //     }
                // });
            } else {
                // 错误，打印返回的数据分析情况
                console.log(data);
            }
        }
    });
    
    // 筛选新闻
    $(document).on('click', '.list-nav li a', function(){
        var type = $(this).data('type');
        $('.list-nav li a').removeClass('active');
        $(this).addClass('active');

        isFilter = true; // 设置处于过滤状态

        $.ajax({
            url: ajaxUrl.typeList,
            type: 'get',
            dataType: 'json',
            data: {
                lang: lang === 'en' ? 'en' : 'zh'
            },
            success: function (data) {
                if (data.status) {
                    // 业务处理
                    var htm = '';

                    data.result = data[type] || [];

                    for (var i = 0; i < data.result.length; i++) {
                        var m = moment(data.result[i].publish_time);
                        var link = '';

                        if(data.result[i].link == '' || !data.result[i].link){
                            link = '/m/news/' + data.result[i].id;
                        }else{
                            link = data.result[i].link;
                        }
                        var more = lang === 'en' ? 'More' : '了解更多';
                        var classname = lang === 'en' ? 'title force-en-font' : 'title';
                        var tag = '';

                        records.forEach(function(value){
                            if(value.code == data.result[i].type){
                                tag = lang === 'en' ? value.en : value.zh;
                                return;
                            }
                        });

                        htm += `
                        <li class="clearfinx">
                            <div class="date">
                                <div class="num1">${m.format('YYYY-MM')}</div>
                                <div class="num2">${m.format('DD')}</div>
                            </div>
                            <div class="info">
                            <h3 class="${classname}"> <a href="${link}" class="">${data.result[i].title}</a></h3>
                                <span class="tag">${tag}</span>
                             </div>
                         </li>`;
                    }
                    $newsList.empty();
                    $newsList.append(htm);
                } else {
                    // 错误，打印返回的数据分析情况
                    console.log(data);
                }
            }
        });
    });

    function getNewsList(url, page, lang) {
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                pageNo: page,
                lang: lang === 'en' ? 'en' : 'zh'
            },
            success: function (data) {
                if (data['news-reports'] && data['news-reports'].length > -1) {
                    // 业务处理
                    data.result = data['news-reports'];
                    var htm = '';

                    for (var i = 0; i < data.result.length; i++) {
                        var m = moment(data.result[i].publish_time);
                        var link = '';

                        if(data.result[i].link == '' || !data.result[i].link){
                            link = '/m/news/' + data.result[i].id + '?lang='+(lang === 'en' ? 'en' : 'zh');
                        }else{
                            link = data.result[i].link;
                        }

                        var more = lang === 'en' ? 'More' : '了解更多';
                        var classname = lang === 'en' ? 'title force-en-font' : 'title';
                        var tag = '';

                        records.forEach(function(value){
                            if(value.code == data.result[i].type){
                                tag = lang === 'en' ? value.en : value.zh;
                                return;
                            }
                        });

                        htm += `
                        <li class="clearfinx">
                            <div class="date">
                                <div class="num1">${m.format('YYYY-MM')}</div>
                                <div class="num2">${m.format('DD')}</div>
                            </div>
                            <div class="info">
                           <h3 class="${classname}"> <a href="${link}" class="">${data.result[i].title}</a></h3>
                                <span class="tag">${tag}</span>
                             </div>
                         </li>`;
                    }

                    $newsList.append(htm);

                    isLoad = false;

                    totalPage = data.pages;
                } else {
                    // 错误，打印返回的数据分析情况
                    console.log(data);
                }
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/m/m-news.js